import { Translations } from '../hooks/useTranslation'

export const segmentCounts = {
    '_10': 10,
    '_20': 20,
    '_30': 30,
    '_40': 40,
    '_50': 50,
}

export type SegmentCountType = keyof typeof segmentCounts

export type RiskType  = 'high' | 'medium' | 'low'

export const riskTypes: Record<RiskType, keyof Translations> = {
    high: 'HIGH',
    medium: 'MEDIUM',
    low: 'LOW',
}

export const segmentColors = [
    'gray',
    'white',
    'green',
    'yellow',
    'purple',
    'orange',
    'blue',
    'magenta'
] as const

export const segmentColorsPalette: Record<SegmentColorType, string> = {
    'gray': '#477285',
    'white': '#dcedf6',
    'green': '#00e700',
    'yellow': '#feec09',
    'purple': '#7f4cea',
    'orange': 'orange',
    'blue': 'blue',
    'magenta': 'magenta'
}

export const drizzleSegmentColorsPalette: Record<SegmentColorType, string> = {
    'gray': '#477285',
    'white': '#dcedf6',
    'green': '#41E7E3',
    'yellow': '#feec09',
    'purple': '#7f4cea',
    'orange': 'orange',
    'blue': 'blue',
    'magenta': 'magenta'
}

export type SegmentColorType = typeof segmentColors[number]

export interface Result {
    color: SegmentColorType
    odd: number
}

export const wheelSchemas: Record<RiskType, Record<SegmentCountType, SegmentColorType[]>> = {
    low: {
        '_10': ['green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray'],
        '_20': ['green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray', 'green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray'],
        '_30': ['green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray', 'green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray', 'green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray'],
        '_40': ['green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray', 'green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray', 'green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray', 'green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray'],
        '_50': ['green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray', 'green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray', 'green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray', 'green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray', 'green', 'white', 'white', 'white', 'gray', 'white', 'white', 'white', 'white', 'gray']
    },
    medium: {
        '_10': ['gray', 'orange', 'gray', 'green', 'gray', 'yellow', 'gray', 'green', 'gray', 'purple'],
        '_20': ['green', 'gray', 'yellow', 'gray', 'yellow', 'gray', 'yellow', 'gray', 'green', 'gray', 'purple', 'gray', 'orange', 'gray', 'yellow', 'gray', 'yellow', 'gray', 'yellow', 'gray'],
        '_30': ['green', 'gray', 'green', 'gray', 'yellow', 'gray', 'green', 'gray', 'yellow', 'gray', 'yellow', 'gray', 'green', 'gray', 'purple', 'gray', 'green', 'gray', 'yellow', 'gray', 'yellow', 'gray', 'orange', 'gray', 'magenta', 'gray', 'green', 'gray', 'yellow', 'gray'],
        '_40': ['yellow', 'gray', 'purple', 'gray', 'yellow', 'gray', 'green', 'gray', 'purple', 'gray', 'green', 'gray', 'green', 'gray', 'yellow', 'gray', 'green', 'gray', 'purple', 'gray', 'green', 'gray', 'yellow', 'gray', 'yellow', 'gray', 'orange', 'gray', 'yellow', 'gray', 'green', 'gray', 'purple', 'gray', 'green', 'gray', 'yellow', 'gray', 'green', 'gray'],
        '_50': ['yellow', 'gray', 'green', 'gray', 'yellow', 'gray', 'green', 'gray', 'purple', 'gray', 'green', 'gray', 'green', 'gray', 'yellow', 'gray', 'green', 'gray', 'purple', 'gray', 'green', 'gray', 'yellow', 'gray', 'green', 'gray', 'yellow', 'gray', 'yellow', 'gray', 'green', 'gray', 'purple', 'gray', 'green', 'gray', 'yellow', 'gray', 'green', 'gray', 'green', 'gray', 'blue', 'gray', 'green', 'gray', 'yellow', 'gray', 'green', 'gray', 'green', 'gray']
    },
    high: {
        '_10': ['gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'orange'],
        '_20': ['gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'orange'],
        '_30': ['gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'orange'],
        '_40': ['gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'orange'],
        '_50': ['gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'gray', 'orange']
    }
}